import React, { useState } from 'react';
import './Explore2.css';
import Explore3 from './Explore3';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import BookExpert from './BookExpert';
import Login from '../Login/Login';

const Explore2 = () => {
  const [selectedOption, setSelectedOption] = useState('Christianity');
  const [showExplore3, setShowExplore3] = useState(false);
  const [showBookExpert, setShowBookExpert] = useState(false);
  const [showLogin, setShowLogin] = useState(false);

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    // Chuyển sang Explore 3 sau khi chọn
    setTimeout(() => {
      setShowExplore3(true);
    }, 300);
  };

  // If user clicked Organizations, show BookExpert
  if (showBookExpert) {
    return <BookExpert />;
  }

  // If user clicked Login, show Login page
  if (showLogin) {
    return <Login />;
  }

  // Nếu đã chọn option, hiển thị Explore3
  if (showExplore3) {
    return <Explore3 />;
  }
  return (
    <div className="explore2-container page-with-header">
      <Header 
        showBookExpert={showBookExpert} 
        setShowBookExpert={setShowBookExpert}
        showLogin={showLogin}
        setShowLogin={setShowLogin}
      />

      {/* Main Content */}
      <div className="main-content">
        <div className="white-container">
          <div className="content-wrapper">
            <h1 className="main-title">Help us get to know you</h1>
            <p className="subtitle">Please answer the following questions.</p>
            
            <div className="question-section">
              <h2 className="question">
                Do you consider yourself to be religious or spiritual? If yes, which one of these do you identify with?
              </h2>
              
              <div className="options-container">
                {['Christianity', 'Islam', 'Hinduism', 'Judaism', 'Buddhism', 'Spiritual', 'Other', 'None'].map((option, index) => (
                  <button
                    key={index}
                    className={`option-button ${selectedOption === option ? 'selected' : ''}`}
                    onClick={() => handleOptionSelect(option)}
                  >
                    {option}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Chat Icon */}
      <div className="chat-icon">
        <div className="monitor">
          <div className="screen">
            <div className="face">
              <div className="eyes">
                <span className="eye">"</span>
                <span className="eye">"</span>
              </div>
              <div className="mouth">)</div>
            </div>
          </div>
          <div className="base"></div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Explore2;

